var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fuel-funds h-margin-top-50 page__container--no-padding",
      attrs: { id: "fuel-funds" }
    },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "loading-indicator" })
        : _vm._e(),
      _vm._v(" "),
      _c("FuelFundsSidebar"),
      _vm._v(" "),
      _c("div", { staticClass: "fuel-funds__main" }, [
        _c("div", { staticClass: "card-block" }, [_c("FuelFundsCredits")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-block h-mobile-margin-bottom-50" },
          [_c("FuelFundsTransactions")],
          1
        )
      ]),
      _vm._v(" "),
      _c("TermsModal")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }